import {
  PrimitiveArraySerializer6xcmeltdozbx as PrimitiveArraySerializer,
  PrimitiveArrayBuilder1tzna3i4eqw54 as PrimitiveArrayBuilder,
} from './CollectionSerializers.mjs';
import { Companion_getInstance1genqokpkr3uz as Companion_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import {
  serializer345btyh1f2y1j as serializer,
  serializer1wpgysz06u9ol as serializer_0,
  serializer3x9uckd1deom as serializer_1,
  serializerodflzzf6s3fp as serializer_2,
  serializer2lw83vwvpnyms as serializer_3,
  serializer1hu9wv9at41ww as serializer_4,
  serializer3ikrxnm8b29d6 as serializer_5,
  serializer1tw0a8bv7lkga as serializer_6,
  serializer1q7c5q67ysppr as serializer_7,
  serializer1r0h5yakm679b as serializer_8,
  serializer36584sjyg5661 as serializer_9,
  serializer3u3hsxnenk49x as serializer_10,
} from '../builtins/BuiltinSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  isCharArray21auq5hbrg68m as isCharArray,
  isDoubleArray1wyh4nyf7pjxn as isDoubleArray,
  isFloatArrayjjscnqphw92j as isFloatArray,
  isIntArrayeijsubfngq38 as isIntArray,
  isShortArraywz30zxwtqi8h as isShortArray,
  isByteArray4nnzfn1x4o3w as isByteArray,
  isBooleanArray35llghle4c6w1 as isBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  charArray2ujmm1qusno00 as charArray,
  booleanArray2jdug9b51huk7 as booleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/arrays.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../KSerializer.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  DoubleCompanionObject_instance43opzxl97v4p as DoubleCompanionObject_instance,
  FloatCompanionObject_instanceokgc3apyetrg as FloatCompanionObject_instance,
  IntCompanionObject_instance3g0jtywew2pgh as IntCompanionObject_instance,
  ShortCompanionObject_instance33mqksfmw0mrs as ShortCompanionObject_instance,
  ByteCompanionObject_instance1r92wkzdy7g72 as ByteCompanionObject_instance,
  BooleanCompanionObject_instance2tls5h1cufcrh as BooleanCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { Companion_instancel8ig9z4updma as Companion_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Primitives.mjs';
import { isLongArray21mxwb8b0y2ii as isLongArray } from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
import {
  Companion_getInstance11ies3wlxhmd7 as Companion_getInstance_0,
  _ULong___init__impl__c78o9k1vasxel72m2l4 as _ULong___init__impl__c78o9k,
  _ULong___get_data__impl__fggpzbbo8lz7f8fnfy as _ULong___get_data__impl__fggpzb,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULong.mjs';
import {
  _ULongArray___get_size__impl__ju6dtr202zbq0mnq27s as _ULongArray___get_size__impl__ju6dtr,
  ULongArray3nd0d80mdwjj8 as ULongArray,
  _ULongArray___init__impl__twm1l39g76mgefo3i0 as _ULongArray___init__impl__twm1l3,
  ULongArray__get_impl_pr71q9399vaqruv2nhv as ULongArray__get_impl_pr71q9,
  _ULongArray___get_storage__impl__28e64jr3nto0sn44go as _ULongArray___get_storage__impl__28e64j,
  _ULongArray___init__impl__twm1l32hx2p2tkf1yk as _ULongArray___init__impl__twm1l3_0,
  ULongArray__set_impl_z19mvhkfwz87ruujvs as ULongArray__set_impl_z19mvh,
} from '../../../../kotlin-kotlin-stdlib/kotlin/ULongArray.mjs';
import {
  Companion_getInstance1crempiiqys0g as Companion_getInstance_1,
  _UInt___init__impl__l7qpdl5ip6p2ldulrs as _UInt___init__impl__l7qpdl,
  _UInt___get_data__impl__f0vqqw30ojw38w2y6td as _UInt___get_data__impl__f0vqqw,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UInt.mjs';
import {
  _UIntArray___get_size__impl__r6l8ci363v3neofz6lm as _UIntArray___get_size__impl__r6l8ci,
  UIntArrayrp6cv44n5v4y as UIntArray,
  _UIntArray___init__impl__ghjpc62fnuksf3r5j9k as _UIntArray___init__impl__ghjpc6,
  UIntArray__get_impl_gp5kza9j53w29hfyue as UIntArray__get_impl_gp5kza,
  _UIntArray___get_storage__impl__92a0v011llee1eit29k as _UIntArray___get_storage__impl__92a0v0,
  _UIntArray___init__impl__ghjpc61ipdjtpvetv4q as _UIntArray___init__impl__ghjpc6_0,
  UIntArray__set_impl_7f2zu2tazd6l4qyq51 as UIntArray__set_impl_7f2zu2,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UIntArray.mjs';
import {
  Companion_getInstance1foc7f9q9rk1s as Companion_getInstance_2,
  _UShort___init__impl__jigrne1e3nphhrejdd8 as _UShort___init__impl__jigrne,
  _UShort___get_data__impl__g02451raj6q6epxg1b as _UShort___get_data__impl__g0245,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShort.mjs';
import {
  _UShortArray___get_size__impl__jqto1b2ufu97m66fe6o as _UShortArray___get_size__impl__jqto1b,
  UShortArray11avpmknxdgvv as UShortArray,
  _UShortArray___init__impl__9b26eftay922a1mq7k as _UShortArray___init__impl__9b26ef,
  UShortArray__get_impl_fnbhmx2opdoe19gpa9f as UShortArray__get_impl_fnbhmx,
  _UShortArray___get_storage__impl__t2jpv5vwyttef17wd6 as _UShortArray___get_storage__impl__t2jpv5,
  _UShortArray___init__impl__9b26ef35x6jp7uuoumr as _UShortArray___init__impl__9b26ef_0,
  UShortArray__set_impl_6d8whp2ks3cfavbrzax as UShortArray__set_impl_6d8whp,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UShortArray.mjs';
import {
  Companion_getInstanceb1xi7131i8df as Companion_getInstance_3,
  _UByte___init__impl__g9hnc49zztd2brjj2m as _UByte___init__impl__g9hnc4,
  _UByte___get_data__impl__jof9qr100nrznmlnqj as _UByte___get_data__impl__jof9qr,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByte.mjs';
import {
  _UByteArray___get_size__impl__h6pkdvvbgvcqs6floa as _UByteArray___get_size__impl__h6pkdv,
  UByteArray2qu4d6gwssdf9 as UByteArray,
  _UByteArray___init__impl__ip4y9n1cvrvnisuepir as _UByteArray___init__impl__ip4y9n,
  UByteArray__get_impl_t5f3hv2p3mnhavewinq as UByteArray__get_impl_t5f3hv,
  _UByteArray___get_storage__impl__d4kctt1j62rlq0o4l4a as _UByteArray___get_storage__impl__d4kctt,
  _UByteArray___init__impl__ip4y9n1laeec2dn8xeh as _UByteArray___init__impl__ip4y9n_0,
  UByteArray__set_impl_jvcicn2pkpqr7t9ajj8 as UByteArray__set_impl_jvcicn,
} from '../../../../kotlin-kotlin-stdlib/kotlin/UByteArray.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import {
  copyOf2p23ljc5f5ea3 as copyOf,
  copyOfgossjg6lh6js as copyOf_0,
  copyOfq9pcgcgbldck as copyOf_1,
  copyOf9mbsebmgnw4t as copyOf_2,
  copyOf3rutauicler23 as copyOf_3,
  copyOf39s58md6y6rn6 as copyOf_4,
  copyOfwy6h3t5vzqpl as copyOf_5,
  copyOf37mht4mx7mjgh as copyOf_6,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CharArraySerializerClass;
function CharArraySerializer() {
  if (CharArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        CharArraySerializer_instance = null;
        super(serializer(Companion_getInstance()));
        CharArraySerializer_instance = this;
      }
      collectionSize_vtpl8l_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_vtpl8l_k$((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_y1jusk_k$(_this__u8e3s4) {
        return new (CharArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_y1jusk_k$((!(_this__u8e3s4 == null) ? isCharArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return charArray(0);
      }
      readElement_8an8ek_k$(decoder, index, builder, checkIndex) {
        builder.append_24rvbl_k$(decoder.decodeCharElement_frbao3_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_8an8ek_k$(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_8an8ek_k$(decoder, index, builder instanceof CharArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_d1b2tw_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeCharElement_5nnekk_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_d1b2tw_k$(encoder, (!(content == null) ? isCharArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'CharArraySerializer', VOID, VOID, [KSerializer()]);
    CharArraySerializerClass = $;
  }
  return CharArraySerializerClass;
}
var CharArraySerializer_instance;
function CharArraySerializer_getInstance() {
  if (CharArraySerializer_instance === VOID)
    new (CharArraySerializer())();
  return CharArraySerializer_instance;
}
var DoubleArraySerializerClass;
function DoubleArraySerializer() {
  if (DoubleArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        DoubleArraySerializer_instance = null;
        super(serializer_0(DoubleCompanionObject_instance));
        DoubleArraySerializer_instance = this;
      }
      collectionSize_ly49h2_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_ly49h2_k$((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_lkkul3_k$(_this__u8e3s4) {
        return new (DoubleArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_lkkul3_k$((!(_this__u8e3s4 == null) ? isDoubleArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return new Float64Array(0);
      }
      readElement_sndxwn_k$(decoder, index, builder, checkIndex) {
        builder.append_3vdidi_k$(decoder.decodeDoubleElement_isei84_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_sndxwn_k$(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_sndxwn_k$(decoder, index, builder instanceof DoubleArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_4uvf1r_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeDoubleElement_a6rqhe_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_4uvf1r_k$(encoder, (!(content == null) ? isDoubleArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'DoubleArraySerializer', VOID, VOID, [KSerializer()]);
    DoubleArraySerializerClass = $;
  }
  return DoubleArraySerializerClass;
}
var DoubleArraySerializer_instance;
function DoubleArraySerializer_getInstance() {
  if (DoubleArraySerializer_instance === VOID)
    new (DoubleArraySerializer())();
  return DoubleArraySerializer_instance;
}
var FloatArraySerializerClass;
function FloatArraySerializer() {
  if (FloatArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        FloatArraySerializer_instance = null;
        super(serializer_1(FloatCompanionObject_instance));
        FloatArraySerializer_instance = this;
      }
      collectionSize_6cqtx_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_6cqtx_k$((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_23p2y2_k$(_this__u8e3s4) {
        return new (FloatArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_23p2y2_k$((!(_this__u8e3s4 == null) ? isFloatArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return new Float32Array(0);
      }
      readElement_45ys0y_k$(decoder, index, builder, checkIndex) {
        builder.append_4kvnvw_k$(decoder.decodeFloatElement_p2q55h_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_45ys0y_k$(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_45ys0y_k$(decoder, index, builder instanceof FloatArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_6fpfj2_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeFloatElement_oe8hn_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_6fpfj2_k$(encoder, (!(content == null) ? isFloatArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'FloatArraySerializer', VOID, VOID, [KSerializer()]);
    FloatArraySerializerClass = $;
  }
  return FloatArraySerializerClass;
}
var FloatArraySerializer_instance;
function FloatArraySerializer_getInstance() {
  if (FloatArraySerializer_instance === VOID)
    new (FloatArraySerializer())();
  return FloatArraySerializer_instance;
}
var LongArraySerializerClass;
function LongArraySerializer() {
  if (LongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        LongArraySerializer_instance = null;
        super(serializer_2(Companion_instance));
        LongArraySerializer_instance = this;
      }
      collectionSize_bpy9i7_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_bpy9i7_k$((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_dxsj26_k$(_this__u8e3s4) {
        return new (LongArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_dxsj26_k$((!(_this__u8e3s4 == null) ? isLongArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return new BigInt64Array(0);
      }
      readElement_5y85e6_k$(decoder, index, builder, checkIndex) {
        builder.append_d2gzns_k$(decoder.decodeLongElement_994anb_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_5y85e6_k$(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_5y85e6_k$(decoder, index, builder instanceof LongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_5nzm62_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeLongElement_ovnxxh_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_5nzm62_k$(encoder, (!(content == null) ? isLongArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'LongArraySerializer', VOID, VOID, [KSerializer()]);
    LongArraySerializerClass = $;
  }
  return LongArraySerializerClass;
}
var LongArraySerializer_instance;
function LongArraySerializer_getInstance() {
  if (LongArraySerializer_instance === VOID)
    new (LongArraySerializer())();
  return LongArraySerializer_instance;
}
var ULongArraySerializerClass;
function ULongArraySerializer() {
  if (ULongArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ULongArraySerializer_instance = null;
        super(serializer_3(Companion_getInstance_0()));
        ULongArraySerializer_instance = this;
      }
      collectionSize_w3r5w1_k$(_this__u8e3s4) {
        return _ULongArray___get_size__impl__ju6dtr(_this__u8e3s4);
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_w3r5w1_k$(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      toBuilder_codxoy_k$(_this__u8e3s4) {
        return new (ULongArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_codxoy_k$(_this__u8e3s4 instanceof ULongArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      empty_bldrb3_k$() {
        return _ULongArray___init__impl__twm1l3(0);
      }
      empty_1lj7f1_k$() {
        return new (ULongArray())(this.empty_bldrb3_k$());
      }
      readElement_ftftn1_k$(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toULong' call
        var this_0 = decoder.decodeInlineElement_s8883o_k$(this.descriptor_1, index).decodeLong_jzt186_k$();
        var tmp$ret$0 = _ULong___init__impl__c78o9k(this_0);
        builder.append_7uknxo_k$(tmp$ret$0);
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_ftftn1_k$(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_ftftn1_k$(decoder, index, builder instanceof ULongArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_byouxy_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.encodeInlineElement_69jjkk_k$(this.descriptor_1, i);
            // Inline function 'kotlin.ULong.toLong' call
            var this_0 = ULongArray__get_impl_pr71q9(content, i);
            var tmp$ret$0 = _ULong___get_data__impl__fggpzb(this_0);
            tmp.encodeLong_vlw3uq_k$(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_byouxy_k$(encoder, content instanceof ULongArray() ? content.storage_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ULongArraySerializer', VOID, VOID, [KSerializer()]);
    ULongArraySerializerClass = $;
  }
  return ULongArraySerializerClass;
}
var ULongArraySerializer_instance;
function ULongArraySerializer_getInstance() {
  if (ULongArraySerializer_instance === VOID)
    new (ULongArraySerializer())();
  return ULongArraySerializer_instance;
}
var IntArraySerializerClass;
function IntArraySerializer() {
  if (IntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        IntArraySerializer_instance = null;
        super(serializer_4(IntCompanionObject_instance));
        IntArraySerializer_instance = this;
      }
      collectionSize_ra2vwi_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_ra2vwi_k$((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_6q9nib_k$(_this__u8e3s4) {
        return new (IntArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_6q9nib_k$((!(_this__u8e3s4 == null) ? isIntArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return new Int32Array(0);
      }
      readElement_scvqun_k$(decoder, index, builder, checkIndex) {
        builder.append_rzagz8_k$(decoder.decodeIntElement_941u6a_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_scvqun_k$(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_scvqun_k$(decoder, index, builder instanceof IntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_3yfenf_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeIntElement_krhhce_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_3yfenf_k$(encoder, (!(content == null) ? isIntArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'IntArraySerializer', VOID, VOID, [KSerializer()]);
    IntArraySerializerClass = $;
  }
  return IntArraySerializerClass;
}
var IntArraySerializer_instance;
function IntArraySerializer_getInstance() {
  if (IntArraySerializer_instance === VOID)
    new (IntArraySerializer())();
  return IntArraySerializer_instance;
}
var UIntArraySerializerClass;
function UIntArraySerializer() {
  if (UIntArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UIntArraySerializer_instance = null;
        super(serializer_5(Companion_getInstance_1()));
        UIntArraySerializer_instance = this;
      }
      collectionSize_lrbfio_k$(_this__u8e3s4) {
        return _UIntArray___get_size__impl__r6l8ci(_this__u8e3s4);
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_lrbfio_k$(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      toBuilder_s0ui4v_k$(_this__u8e3s4) {
        return new (UIntArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_s0ui4v_k$(_this__u8e3s4 instanceof UIntArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      empty_t2t886_k$() {
        return _UIntArray___init__impl__ghjpc6(0);
      }
      empty_1lj7f1_k$() {
        return new (UIntArray())(this.empty_t2t886_k$());
      }
      readElement_qdup8w_k$(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUInt' call
        var this_0 = decoder.decodeInlineElement_s8883o_k$(this.descriptor_1, index).decodeInt_8iq8f5_k$();
        var tmp$ret$0 = _UInt___init__impl__l7qpdl(this_0);
        builder.append_nv72zx_k$(tmp$ret$0);
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_qdup8w_k$(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_qdup8w_k$(decoder, index, builder instanceof UIntArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_yd08vr_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.encodeInlineElement_69jjkk_k$(this.descriptor_1, i);
            // Inline function 'kotlin.UInt.toInt' call
            var this_0 = UIntArray__get_impl_gp5kza(content, i);
            var tmp$ret$0 = _UInt___get_data__impl__f0vqqw(this_0);
            tmp.encodeInt_y5zi3z_k$(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_yd08vr_k$(encoder, content instanceof UIntArray() ? content.storage_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UIntArraySerializer', VOID, VOID, [KSerializer()]);
    UIntArraySerializerClass = $;
  }
  return UIntArraySerializerClass;
}
var UIntArraySerializer_instance;
function UIntArraySerializer_getInstance() {
  if (UIntArraySerializer_instance === VOID)
    new (UIntArraySerializer())();
  return UIntArraySerializer_instance;
}
var ShortArraySerializerClass;
function ShortArraySerializer() {
  if (ShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ShortArraySerializer_instance = null;
        super(serializer_6(ShortCompanionObject_instance));
        ShortArraySerializer_instance = this;
      }
      collectionSize_52p1e3_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_52p1e3_k$((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_7cqv62_k$(_this__u8e3s4) {
        return new (ShortArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_7cqv62_k$((!(_this__u8e3s4 == null) ? isShortArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return new Int16Array(0);
      }
      readElement_jjfy2q_k$(decoder, index, builder, checkIndex) {
        builder.append_hor164_k$(decoder.decodeShortElement_pzg12t_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_jjfy2q_k$(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_jjfy2q_k$(decoder, index, builder instanceof ShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_u8u01q_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeShortElement_4bcdph_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_u8u01q_k$(encoder, (!(content == null) ? isShortArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ShortArraySerializer', VOID, VOID, [KSerializer()]);
    ShortArraySerializerClass = $;
  }
  return ShortArraySerializerClass;
}
var ShortArraySerializer_instance;
function ShortArraySerializer_getInstance() {
  if (ShortArraySerializer_instance === VOID)
    new (ShortArraySerializer())();
  return ShortArraySerializer_instance;
}
var UShortArraySerializerClass;
function UShortArraySerializer() {
  if (UShortArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UShortArraySerializer_instance = null;
        super(serializer_7(Companion_getInstance_2()));
        UShortArraySerializer_instance = this;
      }
      collectionSize_wiwyl_k$(_this__u8e3s4) {
        return _UShortArray___get_size__impl__jqto1b(_this__u8e3s4);
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_wiwyl_k$(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      toBuilder_yw0j9a_k$(_this__u8e3s4) {
        return new (UShortArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_yw0j9a_k$(_this__u8e3s4 instanceof UShortArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      empty_u9tfuv_k$() {
        return _UShortArray___init__impl__9b26ef(0);
      }
      empty_1lj7f1_k$() {
        return new (UShortArray())(this.empty_u9tfuv_k$());
      }
      readElement_tqig65_k$(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUShort' call
        var this_0 = decoder.decodeInlineElement_s8883o_k$(this.descriptor_1, index).decodeShort_jjqk32_k$();
        var tmp$ret$0 = _UShort___init__impl__jigrne(this_0);
        builder.append_8greo0_k$(tmp$ret$0);
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_tqig65_k$(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_tqig65_k$(decoder, index, builder instanceof UShortArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_hu5zzq_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.encodeInlineElement_69jjkk_k$(this.descriptor_1, i);
            // Inline function 'kotlin.UShort.toShort' call
            var this_0 = UShortArray__get_impl_fnbhmx(content, i);
            var tmp$ret$0 = _UShort___get_data__impl__g0245(this_0);
            tmp.encodeShort_gza6si_k$(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_hu5zzq_k$(encoder, content instanceof UShortArray() ? content.storage_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UShortArraySerializer', VOID, VOID, [KSerializer()]);
    UShortArraySerializerClass = $;
  }
  return UShortArraySerializerClass;
}
var UShortArraySerializer_instance;
function UShortArraySerializer_getInstance() {
  if (UShortArraySerializer_instance === VOID)
    new (UShortArraySerializer())();
  return UShortArraySerializer_instance;
}
var ByteArraySerializerClass;
function ByteArraySerializer() {
  if (ByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        ByteArraySerializer_instance = null;
        super(serializer_8(ByteCompanionObject_instance));
        ByteArraySerializer_instance = this;
      }
      collectionSize_edl2xf_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_edl2xf_k$((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_glfche_k$(_this__u8e3s4) {
        return new (ByteArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_glfche_k$((!(_this__u8e3s4 == null) ? isByteArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return new Int8Array(0);
      }
      readElement_kt6f2_k$(decoder, index, builder, checkIndex) {
        builder.append_7q2hf8_k$(decoder.decodeByteElement_c1pisz_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_kt6f2_k$(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_kt6f2_k$(decoder, index, builder instanceof ByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_43scmy_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeByteElement_kft2ib_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_43scmy_k$(encoder, (!(content == null) ? isByteArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'ByteArraySerializer', VOID, VOID, [KSerializer()]);
    ByteArraySerializerClass = $;
  }
  return ByteArraySerializerClass;
}
var ByteArraySerializer_instance;
function ByteArraySerializer_getInstance() {
  if (ByteArraySerializer_instance === VOID)
    new (ByteArraySerializer())();
  return ByteArraySerializer_instance;
}
var UByteArraySerializerClass;
function UByteArraySerializer() {
  if (UByteArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        UByteArraySerializer_instance = null;
        super(serializer_9(Companion_getInstance_3()));
        UByteArraySerializer_instance = this;
      }
      collectionSize_fw9muz_k$(_this__u8e3s4) {
        return _UByteArray___get_size__impl__h6pkdv(_this__u8e3s4);
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_fw9muz_k$(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      toBuilder_zbmv22_k$(_this__u8e3s4) {
        return new (UByteArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_zbmv22_k$(_this__u8e3s4 instanceof UByteArray() ? _this__u8e3s4.storage_1 : THROW_CCE());
      }
      empty_ne95yt_k$() {
        return _UByteArray___init__impl__ip4y9n(0);
      }
      empty_1lj7f1_k$() {
        return new (UByteArray())(this.empty_ne95yt_k$());
      }
      readElement_9aehtt_k$(decoder, index, builder, checkIndex) {
        // Inline function 'kotlin.toUByte' call
        var this_0 = decoder.decodeInlineElement_s8883o_k$(this.descriptor_1, index).decodeByte_jzz7je_k$();
        var tmp$ret$0 = _UByte___init__impl__g9hnc4(this_0);
        builder.append_224cm8_k$(tmp$ret$0);
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_9aehtt_k$(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_9aehtt_k$(decoder, index, builder instanceof UByteArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_k885v6_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var tmp = encoder.encodeInlineElement_69jjkk_k$(this.descriptor_1, i);
            // Inline function 'kotlin.UByte.toByte' call
            var this_0 = UByteArray__get_impl_t5f3hv(content, i);
            var tmp$ret$0 = _UByte___get_data__impl__jof9qr(this_0);
            tmp.encodeByte_6txfee_k$(tmp$ret$0);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_k885v6_k$(encoder, content instanceof UByteArray() ? content.storage_1 : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'UByteArraySerializer', VOID, VOID, [KSerializer()]);
    UByteArraySerializerClass = $;
  }
  return UByteArraySerializerClass;
}
var UByteArraySerializer_instance;
function UByteArraySerializer_getInstance() {
  if (UByteArraySerializer_instance === VOID)
    new (UByteArraySerializer())();
  return UByteArraySerializer_instance;
}
var BooleanArraySerializerClass;
function BooleanArraySerializer() {
  if (BooleanArraySerializerClass === VOID) {
    class $ extends PrimitiveArraySerializer() {
      constructor() {
        BooleanArraySerializer_instance = null;
        super(serializer_10(BooleanCompanionObject_instance));
        BooleanArraySerializer_instance = this;
      }
      collectionSize_6kmfg7_k$(_this__u8e3s4) {
        return _this__u8e3s4.length;
      }
      collectionSize_kqukvo_k$(_this__u8e3s4) {
        return this.collectionSize_6kmfg7_k$((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      toBuilder_533e2y_k$(_this__u8e3s4) {
        return new (BooleanArrayBuilder())(_this__u8e3s4);
      }
      toBuilder_5lxc6t_k$(_this__u8e3s4) {
        return this.toBuilder_533e2y_k$((!(_this__u8e3s4 == null) ? isBooleanArray(_this__u8e3s4) : false) ? _this__u8e3s4 : THROW_CCE());
      }
      empty_1lj7f1_k$() {
        return booleanArray(0);
      }
      readElement_nw7y52_k$(decoder, index, builder, checkIndex) {
        builder.append_3zsgtj_k$(decoder.decodeBooleanElement_vuyhtj_k$(this.descriptor_1, index));
      }
      readElement_36l3ep_k$(decoder, index, builder, checkIndex) {
        return this.readElement_nw7y52_k$(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      readElement_9d70uk_k$(decoder, index, builder, checkIndex) {
        return this.readElement_nw7y52_k$(decoder, index, builder instanceof BooleanArrayBuilder() ? builder : THROW_CCE(), checkIndex);
      }
      writeContent_ostd9q_k$(encoder, content, size) {
        var inductionVariable = 0;
        if (inductionVariable < size)
          do {
            var i = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            encoder.encodeBooleanElement_ydht7q_k$(this.descriptor_1, i, content[i]);
          }
           while (inductionVariable < size);
      }
      writeContent_wekas_k$(encoder, content, size) {
        return this.writeContent_ostd9q_k$(encoder, (!(content == null) ? isBooleanArray(content) : false) ? content : THROW_CCE(), size);
      }
    }
    initMetadataForObject($, 'BooleanArraySerializer', VOID, VOID, [KSerializer()]);
    BooleanArraySerializerClass = $;
  }
  return BooleanArraySerializerClass;
}
var BooleanArraySerializer_instance;
function BooleanArraySerializer_getInstance() {
  if (BooleanArraySerializer_instance === VOID)
    new (BooleanArraySerializer())();
  return BooleanArraySerializer_instance;
}
var CharArrayBuilderClass;
function CharArrayBuilder() {
  if (CharArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_24rvbl_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'CharArrayBuilder');
    CharArrayBuilderClass = $;
  }
  return CharArrayBuilderClass;
}
var DoubleArrayBuilderClass;
function DoubleArrayBuilder() {
  if (DoubleArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_0(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_3vdidi_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_0(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'DoubleArrayBuilder');
    DoubleArrayBuilderClass = $;
  }
  return DoubleArrayBuilderClass;
}
var FloatArrayBuilderClass;
function FloatArrayBuilder() {
  if (FloatArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_1(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_4kvnvw_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_1(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'FloatArrayBuilder');
    FloatArrayBuilderClass = $;
  }
  return FloatArrayBuilderClass;
}
var LongArrayBuilderClass;
function LongArrayBuilder() {
  if (LongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_2(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_d2gzns_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_2(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'LongArrayBuilder');
    LongArrayBuilderClass = $;
  }
  return LongArrayBuilderClass;
}
var ULongArrayBuilderClass;
function ULongArrayBuilder() {
  if (ULongArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = _ULongArray___get_size__impl__ju6dtr(bufferWithData);
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (_ULongArray___get_size__impl__ju6dtr(this.buffer_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.buffer_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_ULongArray___get_size__impl__ju6dtr(this.buffer_1), 2));
          tmp.buffer_1 = _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
        }
      }
      append_7uknxo_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        ULongArray__set_impl_z19mvh(tmp, _unary__edvuaz, c);
      }
      build_ouougs_k$() {
        var tmp0 = this.buffer_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.position_1;
        return _ULongArray___init__impl__twm1l3_0(copyOf_2(_ULongArray___get_storage__impl__28e64j(tmp0), newSize));
      }
      build_boe8ts_k$() {
        return new (ULongArray())(this.build_ouougs_k$());
      }
    }
    initMetadataForClass($, 'ULongArrayBuilder');
    ULongArrayBuilderClass = $;
  }
  return ULongArrayBuilderClass;
}
var IntArrayBuilderClass;
function IntArrayBuilder() {
  if (IntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_3(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_rzagz8_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_3(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'IntArrayBuilder');
    IntArrayBuilderClass = $;
  }
  return IntArrayBuilderClass;
}
var UIntArrayBuilderClass;
function UIntArrayBuilder() {
  if (UIntArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = _UIntArray___get_size__impl__r6l8ci(bufferWithData);
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (_UIntArray___get_size__impl__r6l8ci(this.buffer_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.buffer_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UIntArray___get_size__impl__r6l8ci(this.buffer_1), 2));
          tmp.buffer_1 = _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
        }
      }
      append_nv72zx_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        UIntArray__set_impl_7f2zu2(tmp, _unary__edvuaz, c);
      }
      build_14x7st_k$() {
        var tmp0 = this.buffer_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.position_1;
        return _UIntArray___init__impl__ghjpc6_0(copyOf_3(_UIntArray___get_storage__impl__92a0v0(tmp0), newSize));
      }
      build_boe8ts_k$() {
        return new (UIntArray())(this.build_14x7st_k$());
      }
    }
    initMetadataForClass($, 'UIntArrayBuilder');
    UIntArrayBuilderClass = $;
  }
  return UIntArrayBuilderClass;
}
var ShortArrayBuilderClass;
function ShortArrayBuilder() {
  if (ShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_4(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_hor164_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_4(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'ShortArrayBuilder');
    ShortArrayBuilderClass = $;
  }
  return ShortArrayBuilderClass;
}
var UShortArrayBuilderClass;
function UShortArrayBuilder() {
  if (UShortArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = _UShortArray___get_size__impl__jqto1b(bufferWithData);
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (_UShortArray___get_size__impl__jqto1b(this.buffer_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.buffer_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UShortArray___get_size__impl__jqto1b(this.buffer_1), 2));
          tmp.buffer_1 = _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
        }
      }
      append_8greo0_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        UShortArray__set_impl_6d8whp(tmp, _unary__edvuaz, c);
      }
      build_f3otwq_k$() {
        var tmp0 = this.buffer_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.position_1;
        return _UShortArray___init__impl__9b26ef_0(copyOf_4(_UShortArray___get_storage__impl__t2jpv5(tmp0), newSize));
      }
      build_boe8ts_k$() {
        return new (UShortArray())(this.build_f3otwq_k$());
      }
    }
    initMetadataForClass($, 'UShortArrayBuilder');
    UShortArrayBuilderClass = $;
  }
  return UShortArrayBuilderClass;
}
var ByteArrayBuilderClass;
function ByteArrayBuilder() {
  if (ByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_5(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_7q2hf8_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_5(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'ByteArrayBuilder');
    ByteArrayBuilderClass = $;
  }
  return ByteArrayBuilderClass;
}
var UByteArrayBuilderClass;
function UByteArrayBuilder() {
  if (UByteArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = _UByteArray___get_size__impl__h6pkdv(bufferWithData);
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (_UByteArray___get_size__impl__h6pkdv(this.buffer_1) < requiredCapacity) {
          var tmp = this;
          var tmp0 = this.buffer_1;
          // Inline function 'kotlin.collections.copyOf' call
          var newSize = coerceAtLeast(requiredCapacity, imul(_UByteArray___get_size__impl__h6pkdv(this.buffer_1), 2));
          tmp.buffer_1 = _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
        }
      }
      append_224cm8_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        UByteArray__set_impl_jvcicn(tmp, _unary__edvuaz, c);
      }
      build_a4y2t4_k$() {
        var tmp0 = this.buffer_1;
        // Inline function 'kotlin.collections.copyOf' call
        var newSize = this.position_1;
        return _UByteArray___init__impl__ip4y9n_0(copyOf_5(_UByteArray___get_storage__impl__d4kctt(tmp0), newSize));
      }
      build_boe8ts_k$() {
        return new (UByteArray())(this.build_a4y2t4_k$());
      }
    }
    initMetadataForClass($, 'UByteArrayBuilder');
    UByteArrayBuilderClass = $;
  }
  return UByteArrayBuilderClass;
}
var BooleanArrayBuilderClass;
function BooleanArrayBuilder() {
  if (BooleanArrayBuilderClass === VOID) {
    class $ extends PrimitiveArrayBuilder() {
      constructor(bufferWithData) {
        super();
        this.buffer_1 = bufferWithData;
        this.position_1 = bufferWithData.length;
        this.ensureCapacity_mq7liq_k$(10);
      }
      get_position_cjjt7w_k$() {
        return this.position_1;
      }
      ensureCapacity_mq7liq_k$(requiredCapacity) {
        if (this.buffer_1.length < requiredCapacity)
          this.buffer_1 = copyOf_6(this.buffer_1, coerceAtLeast(requiredCapacity, imul(this.buffer_1.length, 2)));
      }
      append_3zsgtj_k$(c) {
        this.ensureCapacity$default_4tzhe_k$();
        var tmp = this.buffer_1;
        var _unary__edvuaz = this.position_1;
        this.position_1 = _unary__edvuaz + 1 | 0;
        tmp[_unary__edvuaz] = c;
      }
      build_boe8ts_k$() {
        return copyOf_6(this.buffer_1, this.position_1);
      }
    }
    initMetadataForClass($, 'BooleanArrayBuilder');
    BooleanArrayBuilderClass = $;
  }
  return BooleanArrayBuilderClass;
}
//region block: exports
export {
  BooleanArraySerializer_getInstance as BooleanArraySerializer_getInstance1u7esswhuhgdo,
  ByteArraySerializer_getInstance as ByteArraySerializer_getInstance2fuv9a137bvc4,
  CharArraySerializer_getInstance as CharArraySerializer_getInstance2mu447sxrz0td,
  DoubleArraySerializer_getInstance as DoubleArraySerializer_getInstance14oy86gxun29t,
  FloatArraySerializer_getInstance as FloatArraySerializer_getInstancexaku2izexxhx,
  IntArraySerializer_getInstance as IntArraySerializer_getInstanceqou69s68jhpv,
  LongArraySerializer_getInstance as LongArraySerializer_getInstance3jvz8bkl0kqnj,
  ShortArraySerializer_getInstance as ShortArraySerializer_getInstance1401rzbbbe6ma,
  UByteArraySerializer_getInstance as UByteArraySerializer_getInstance1d8h5wo399t1t,
  UIntArraySerializer_getInstance as UIntArraySerializer_getInstancec7tztknra5r3,
  ULongArraySerializer_getInstance as ULongArraySerializer_getInstancehm7rd2yih7u8,
  UShortArraySerializer_getInstance as UShortArraySerializer_getInstance3lvdig2cpj19w,
};
//endregion

//# sourceMappingURL=PrimitiveArraysSerializers.mjs.map
